<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate

    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: "会员ID", prop: "name", type: "input", isFuzzy: true, placeholder: "请输入会员ID"},
          ],
        },
        // 更多功能
        toolConfig: [
          {
            label: '兑换',
            code: 'exchange'
          },
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          columns: [
            {label: '门店名称', prop: 'name', width: '190', align: 'center'},
            {label: '礼品编码', prop: 'code', width: '140', align: 'center'},
            {
              label: '礼品名称',
              prop: 'discountType',
              width: '140',
              align: 'center',
            },
            {label: '兑换数量', prop: 'memberBirthday', width: '100', align: 'center'},
            {label: '需要积分', prop: 'phone', width: '100', align: 'center'},
            {label: '会员限换数量', prop: 'address', width: '200', align: 'center'},
            {label: '开始日期', prop: 'startDttm', width: '135', align: 'center'},
            {label: '结束日期', prop: 'endDttm', width: '135', align: 'center'},
          ],
          url: api.member.archives
        },
        addColumns: {
          labelWidth: '120px',
          span: 12,
          columns: [
            {
              label: '会员姓名',
              type: 'input',
              prop: 'name',
              rule: [{required: true, message: '请输入会员姓名'}],
              placeholder: "请输入会员姓名"
            },
          ],
          url: api.member.archives
        },
      };
    },
    created() {
    },
    methods: {}
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/member/integral/Exchange.vue